import { render } from "./IndexPolicyDetailPage.vue?vue&type=template&id=bdb119b2"
import script from "./IndexPolicyDetailPage.vue?vue&type=script&lang=js"
export * from "./IndexPolicyDetailPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__